import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightTear = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 91,
	viewBox: "0 0 11 91",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 91,
			width: 11,
			height: 91,
			rx: 5.5,
			transform: "rotate(180 11 91)",
			fill: "url(#paint0_linear_1416_12752)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1416_12752",
			x1: 17.1111,
			y1: 59.6623,
			x2: 16.9625,
			y2: 182.001,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#2E9DD8" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .526042,
					stopColor: "#90C4E1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgLightTear);
export { ForwardRef as ReactComponent };
